import { createAction } from '@ngrx/store';

const loadInvitesSidebar = createAction('[Invites Sidebar] Load');

export const invitesSidebarActions = {
  loadInvitesSidebar,
};
